import {Component} from '@angular/core';

import {Plugins, StatusBarStyle} from '@capacitor/core';
import {Platform} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {PatternRepository} from '../repositories/pattern.repository';

import smoothscroll from 'smoothscroll-polyfill';
import AnalyticsService from "../services/analytics.service";
import {Storage} from '@ionic/storage';
import {Router} from '@angular/router';


@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.css']
})
export class AppComponent {
    constructor(
        private platform: Platform,
        private splashScreen: SplashScreen,
        private statusBar: StatusBar,
        private analytics: AnalyticsService,
        private patternRepository: PatternRepository,
        private storage: Storage,
        private router: Router
    ) {
        this.initializeApp();
    }

    initializeApp() {
        smoothscroll.polyfill();

        this.platform.ready().then(() => {

            // Preload all patterns
            this.patternRepository.all();

            this.splashScreen.hide();

            if (this.platform.is('android') || this.platform.is('ios')) {
                this.statusBar.styleDefault();
            }

            if (this.platform.is('android')) {
                const AndroidStatusBar = Plugins.StatusBar;

                AndroidStatusBar.setStyle({style: StatusBarStyle.Light});
                AndroidStatusBar.setBackgroundColor({
                    color: '#ECE1D3',
                });
            }

            this.storage.get('analyticsText')
                .then(analyticsText => {
                    if (!analyticsText) {
                        this.router.navigate([ '/cookies' ], {
                            replaceUrl: true
                        });
                    } else {
                        this.storage.get('analytics')
                            .then(analytics => {
                                this.analytics.toggleAnalytics(!!analytics);
                            });
                    }
                });
        });
    }
}
